import { useQuery } from '@tanstack/react-query'
import type { Condicao } from '@peniel/shared'

import { listarProdutos } from '../api/produtos.js'
import { chaves } from '../api/chaves.js'

/**
 * Prévia curada de uma seção da home.
 *
 * A home NÃO lista o catálogo inteiro: com 40+ bikes isso significaria mandar
 * todos os produtos e todas as imagens para todo visitante. Cada seção mostra
 * as primeiras N (destaque primeiro) e linka para `/bicicletas`.
 */
export function useProdutosVitrine(condicao: Condicao, quantidade: number) {
  return useQuery({
    queryKey: chaves.produtos.vitrine(condicao),
    queryFn: () =>
      listarProdutos({ condicao, ordenar: 'destaque', porPagina: quantidade, pagina: 1 }),
  })
}
